// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// accessibility-announcement
import {setAccessibilityAnnouncement} from '../actions/accessibility-announcement';

class AccessibilityAnnouncement extends React.Component {
  static propTypes = {
    accessibilityAnnouncement: PropTypes.string,
    resetAnnouncement: PropTypes.func.isRequired
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {resetAnnouncement} = this.props;

    // Delay clearing of the announcement so the screen reader
    // doesn't skip the actual announcement.
    if (nextProps.accessibilityAnnouncement) {
      setTimeout(() => resetAnnouncement(), 500);
    }
  }

  render() {
    const {accessibilityAnnouncement} = this.props;

    return (
      <div
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {accessibilityAnnouncement &&
          <span>{accessibilityAnnouncement}</span>
        }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => (
  {resetAnnouncement: () => dispatch(setAccessibilityAnnouncement(''))}
);

const mapStateToProps = ({accessibilityAnnouncement}) => (
  {accessibilityAnnouncement}
);

export default connect(mapStateToProps, mapDispatchToProps)(AccessibilityAnnouncement);
